<template>
    <div>
        <Modal
            :show="modalVisibility"
            :overflowHidden="false"
            class="overflow-visible"
            @close="closeModal"
        >
            <div class="flex flex-col items-center px-6 text-default-1">
                <h1 class="text-body-2 font-medium mt-3 mb-2 w-full whitespace-normal break-all text-center">
                    <span>{{ formattedTitle }}</span>
                    <br>
                    <span>{{formattedTitleType}}</span>
                </h1>
                <div class="xxs:p-4 bg-white rounded border border-white lg:px-0 lg:pt-4 lg:pb-0 box-border w-full">
                    <p class="text-center">
                        Are you sure you want to remove {{ formattedType }}?<br>
                        The folder will no longer be available to use.
                    </p>

                    <div class="w-full flex items-center justify-center mt-6">
                        <Button
                            :disabled="loading"
                            class="xxs:w-full lg:w-auto self-start"
                            buttonType="primary"
                            :loading="loading"
                            @click="emit('delete')"
                        >Delete</Button>

                        <Button
                            class="xxs:w-full lg:w-auto self-start ml-4"
                            buttonType="ghost"
                            @click="closeModal"
                        >Cancel</Button>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script setup>
import {computed} from 'vue';
import Modal from "@/components/core/Modal.vue";
import Button from "@/components/core/Button.vue";
import tailwindConfig from '@/../tailwind.config';
import resolveConfig from "tailwindcss/resolveConfig";
import {useTheme} from "@/stores/ThemeStore";

const emit = defineEmits(['close', 'delete']);

const props = defineProps({
    modalVisibility: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: 'file',
    },
    selectedDocuments: {
        type: Object,
        default: () => {},
    },
    totalDocuments: {
        type: Number,
        default: 0,
    },
    // single file is used when deleting a single file through the options menu
    singleFile: {
        type: Object,
        default: null,
    }
});

function closeModal() {
    emit('close')
}

const documentType = computed(() => {
    if(props.singleFile) {
        return props.singleFile.documentable_type
    }

    return 'files';
})

const formattedTitle = computed(() => {
    if(!props.singleFile) {
        let count;

        if(props.selectedDocuments.include === '*') {
            count = props.totalDocuments - props.selectedDocuments.exclude.length
        } else {
            count = props.selectedDocuments.include.length
        }

        return `Delete ${count}`
    }

    return `Delete "${props.singleFile.documentable.title}"`
})

const formattedTitleType = computed(() => {
    if(!props.singleFile) {
        return `documents`
    }

    return `${documentType.value}`
})

const formattedType = computed(() => {
    if(!props.singleFile) {
        return 'these documents'
    }

    if(documentType.value === 'folder') {
        return 'this folder'
    }

    return 'this file'
})
</script>